import { jsxs as d, jsx as o } from "react/jsx-runtime";
import { forwardRef as l, useContext as m } from "react";
import { R as n } from "./FieldSet-BM_JN_UL.mjs";
import "../button/ArrowButton-DqViaPQ-.mjs";
const p = l(
  ({ label: a, name: e, className: r = "", ...t }, s) => {
    const { radioName: i } = m(n);
    return /* @__PURE__ */ d("label", { className: `rds-radio-toggle ${r}`, children: [
      /* @__PURE__ */ o("input", { className: "rds-radio-toggle__input", ...t, ref: s, type: "radio", name: i || e }),
      /* @__PURE__ */ o("span", { className: "rds-radio-toggle__label", children: a })
    ] });
  }
);
p.displayName = "RadioToggleInput";
export {
  p as R
};
